<template>
  <div class="form-group-beside row no-gutters" :class="underlineFieldClass">
    <div class="col-2 col-md-6">
      <label :for="machine_name" class="closed-caption-label entry-field__label">
        <div>{{ display_name }} <em class="yellow no-style" v-if="required == true">*</em></div>
        <div class="description" v-if="description" v-html="description"></div>
      </label>
    </div>
    <div class="col-10 col-md-6 input-wrapper pl-3">
      <input type="hidden" :id="machine_name" :name="machine_name" v-model="entry[machine_name]">
      <fyc-cropper v-if="update_allowed" :initval="entry[machine_name]" @closeModalClicked="closeModal" @croppedImage="saveImage"  @deleteImage="deleteImage(machine_name)" :fieldname="machine_name" :minimum_width="minimum_width" :minimum_height="minimum_height"></fyc-cropper>
      <img :src="entry[machine_name]" v-if="!update_allowed">
      <div class="d-flex align-items-center pull-right pr-3" v-if="role == 'marketing'">
        <a :href="entry[machine_name]" download target="_blank" class="btn btn-primary">Download</a>
      </div>
    </div>
  </div>
</template>

<script>
import modal from './Modal.vue';
import upload from './icons/upload.vue';
import trash from './icons/trash.vue';
import FycCropper from "./FycCropper";

export default {
  components: {FycCropper, modal, upload, trash },
  props: ['actionurl', 'entry', 'saved_filename', 'description', 'display_name', 'required', 'machine_name', 'view_url', 'update_allowed', 'minimum_width', 'minimum_height', 'entrantImage', 'role'],
  data() {
    return {
      filename: this.saved_filename,
      modalTriggerConfirmDelete: false,
      underlineFieldClass: '',
    }
  },
  methods: {
    activateDeleteCCFilePopup: function() {
      let app = this;
      app.modalTriggerConfirmDelete = true;
    },
    underlineFields() {
      let app = this;
      let submitFormBlock = true;
      // If required and filename is blank, don't submit the form!
      if((app.required == 1) && (app.filename == '')) {
        submitFormBlock = false;
        app.underlineFieldClass = ' required';
      }
      return submitFormBlock;
    },
    closeModal: function() {
      $('.html').removeClass('overlay');
      this.signatureNeeded = false;
    },
    cropImage() {
      console.log('crop image method!!')
      // get image data for post processing, e.g. upload or setting image src
    //   this.cropImg = this.$refs.cropper.getCroppedCanvas().toDataURL();
    //   this.orderinfo.cable_network_logo = this.$refs.cropper.getCroppedCanvas().toDataURL();
    },
    saveImage: function(image) {
      let app = this;
      app.isLoading = true;
      app.entry[app.machine_name] = image;
      app.updateForm();
    },
    deleteImage: function(fieldName) {
      this.entry[fieldName] = '';
      this.updateForm(true);
    },
    updateForm: function(refreshPage) {
      let app = this;
      // if((that.role === 'admin') && (adminSave !== true)) {
      //   return false;
      // }
      let actionUrl = `/entrant/` + app.entry.id;
      window.axios(
          {
            method: 'post',
            url: actionUrl,
            data: {
              [app.machine_name]: app.entry[app.machine_name]
            }
          }).then(function(response) {
            console.log('here')
        let dataBack = response.data;
        if(refreshPage) { //((that.role === 'admin') || (adminSave)) {
          location.reload();
        }
      }).catch(function (error) {
        // handle error
        console.log('This is the error returned', error);
      });
    },
  }
}
</script>
